import React, { Component } from "react";
import ProfileList from "./profileList";
import Loader from "../loader";
import ErrorComponent from "../errorComponent";

let base_uri = "";

class Profiles extends Component {
  state = {
    loading: true,
    error: false,
    data: { data: [] },
    currentQueue: 0, // Holds queue id
    locations: { data: [] }
  };

  handleTabChange = index => {
    // Check for change
    if (index === this.state.currentQueue) {
      return;
    } else {
      this.setState({
        currentQueue: index
      });
    }
  };

  handleErrors(response) {
    // Check for !200 response
    if (!response.ok) {
      throw Error(response.status);
    }
    return response;
  }

  sortQueues(data) {
    // After retrieving queues, sort queues to requested order
    const newData = [];
    this.props.config.field_profile_list.forEach(function(item, i) {
      data.forEach(function(queue) {
        if (queue.nid === item.field_profile_queue) {
          newData[i] = queue;
        }
      });
    });
    data = newData;
    this.setState({currentQueue: this.props.config.field_profile_list[0].field_profile_queue});
    return data;
  }

  componentDidMount() {
    switch (window.location.hostname) {
      case "react.drup2-dev.uvm.edu":
      case "localhost":
        base_uri = "https://content.drup2-dev.uvm.edu/";
        break;
      case "react.drup2-staging.uvm.edu":
        base_uri = "https://content.drup2-staging.uvm.edu/";
        break;
      default:
        base_uri = "https://www.uvm.edu/content/";
    }
    // Get states list
    const LOCATIONS_URL = base_uri + "shared/json/taxonomy/locations?filter[field_boolean]=1";
    for (let i = 0; i < 10; i++) {
      fetch(LOCATIONS_URL)
        .then(this.handleErrors) // handles response errors like 404
        .then(response => response.json())
        .then(data => this.setState({ locations: data.data.tree }))
        .catch(error => this.setState({ loading: false, error })); // Handles request errors like CORS
      if (this.state.loading) {
        break;
      }
    }
    // Get profiles
    const PROFILES_URL = base_uri + "shared/json/node?filter[nid]=1407,1408,1409,3777&include=field_profiles";
    for (let i = 0; i < 10; i++) {
      fetch(PROFILES_URL)
        .then(this.handleErrors) // handles response errors like 404
        .then(response => response.json())
        .then(data =>
          this.setState({
            loading: false,
            data: this.sortQueues(data.data),
            //currentQueue: data.data[0].nid,
          })
        )
        .catch(error => this.setState({ loading: false, error })); // Handles request errors like CORS */
      if (this.state.loading) {
        break;
      }
    }
  }

  render() {
    const { loading, currentQueue, data, error, locations } = this.state;
    return loading ? (
      <Loader />
    ) : error ? (
      <ErrorComponent error={error} />
    ) : data !== undefined && locations !== undefined ? ( // Trap for null data
      <ProfileList
        locations={locations}
        config={this.props.config}
        onTabChange={this.handleTabChange}
        currentQueue={currentQueue}
        data={data}
      />
    ) : (
      <p>No contacts found.</p>
    );
  }
}

export default Profiles;
